import curry from 'lodash.curry';

export const addPropertyPrefix = curry((prefix, fn, prop) => {
  return fn(`${prefix}.${prop}`);
});

export const onCheckBoxChange = onPropertyChange => event => onPropertyChange(event.target.checked);
export const onRadioButtonChange = onPropertyChange => event => onPropertyChange(parseInt(event.target.value));
export const onSliderChange = onPropertyChange => (_, value) => {
  onPropertyChange(value);
};

export const onAutosuggestObjectChange = onPropertyChange => suggestion => {
  onPropertyChange(suggestion.value, suggestion.name);
};

export const onAutoCompleteChange = onPropertyChange => event => {
  onPropertyChange(event ? Object.values(event)[0] : '');
};

export const onDynamicInputChange = onPropertyChange => value => onPropertyChange(value?.value ?? value);

export const onTextBoxChange =
  (onPropertyChange, options = { uppercase: false, rejectWhitespace: false }) =>
  event => {
    const { uppercase, rejectWhitespace } = options;
    let text = uppercase ? event.target.value.toUpperCase() : event.target.value;

    if (rejectWhitespace) {
      if (text.includes(' ')) text = text.replace(/ /g, '');
    }

    onPropertyChange(text);
  };
